import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import type { GraphNode } from 'features/knowledgeDocumentViewer/graph/graphTypes'
import {
  loadNodePageDestinations,
  type PageDestination,
} from 'features/knowledgeDocumentViewer/graph/nodePageDestinations'
import { postFetcher } from 'features/rolodex/fetchers'
import useSWR from 'swr'

type NodePageDestinationsKey = [string, string, GraphNode['tags']]

export function useNodePageDestinations(node: Pick<GraphNode, 'id' | 'tags'>): {
  destinations: PageDestination[] | undefined
  isLoading: boolean
  error: Error | undefined
} {
  const { ROLODEX_URL } = useRuntimeVariables()
  const { authorizedAxios, isAuthenticated } = useGeckoAuth()
  const key: NodePageDestinationsKey | null = isAuthenticated
    ? [`${ROLODEX_URL}/api/v2/entries/load`, node.id, node.tags]
    : null
  const { data, error, isLoading } = useSWR<
    PageDestination[],
    Error,
    NodePageDestinationsKey | null
  >(
    key,
    ([url, nodeId, tags]) =>
      loadNodePageDestinations(nodeId, tags, (query) =>
        postFetcher(url, JSON.stringify(query), authorizedAxios)
      ),
    { revalidateOnFocus: false, errorRetryCount: 2 }
  )
  return { destinations: data, isLoading, error }
}
